import nl from "date-fns/locale/nl";
import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { updateDateRange } from "../services/general/actions";
// zie https://github.com/Hacker0x01/react-datepicker/blob/master/docs/datepicker.md

function DatePickerComponent(props) {
  const [startDate, setStartDate] = useState(new Date());

  //const [endDate, setEndDate] = useState(null);
  const [endDate, setEndDate] = useState(new Date(Date.now() + 6.048e8));

  const onChangeStart = (date) => {
    setStartDate(date);
  };
  const onChangeEnd = (date) => {
    setEndDate(date);
  };

  registerLocale("nl", nl);

  useEffect(() => {
    props.updateDateRange([startDate, endDate]);
    // console.log([startDate, endDate]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
      }}
    >
      <div>
        <DatePicker
          selected={startDate}
          onChange={onChangeStart}
          startDate={startDate}
          dateFormat="dd.MM.yyyy"
          showWeekNumbers
          locale="nl"
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "60px",
        }}
      >
        <p style={{ fontWeight: "bold" }}>tot</p>
      </div>
      <div>
        <DatePicker
          selected={endDate}
          onChange={onChangeEnd}
          endDate={endDate}
          minDate={startDate}
          dateFormat="dd.MM.yyyy"
          showWeekNumbers
          locale="nl"
        />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    chosenDateRange: state.general.currentDateRange,
  };
}

export default connect(mapStateToProps, {
  updateDateRange,
})(DatePickerComponent);
